import {Box, Slide} from '@mui/material';
import PropTypes from 'prop-types';
import React from 'react';

import {LeftDrawer} from '@app/components/common/Drawers';
import useCollectionParams from '@app/hooks/useCollectionParams';
import CollectionsPanel from '@components/Collections/CollectionsPanel';
import FeaturesPanel from '@components/Features/FeaturesPanel';

const CollectionsSidebar = ({open, onClose, ...props}) => {
  const {collectionId} = useCollectionParams();

  return (
    <LeftDrawer
      open={open}
      onClose={onClose}
      PaperProps={{
        'data-testid': 'orders-sidebar',
      }}
      {...props}
    >
      <Box
        sx={{
          height: '100%',
          position: 'relative',
          overflow: 'hidden',
        }}
      >
        <Slide in={!!collectionId} appear={false} direction="left" mountOnEnter>
          <Box
            sx={{
              height: collectionId ? '100%' : 0,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <FeaturesPanel />
          </Box>
        </Slide>
        <Slide in={!collectionId} direction="right">
          <Box
            sx={{
              height: !collectionId ? '100%' : 0,
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <CollectionsPanel />
          </Box>
        </Slide>
      </Box>
    </LeftDrawer>
  );
};

CollectionsSidebar.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
};

export default CollectionsSidebar;
